import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import ProfileContainer from './ProfileContainer'


const ProfileRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><ProfileContainer></ProfileContainer></Provider>
}

ProfileRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default ProfileRoot
